<template>
  <div :class="faq ? 'default-faq' : 'blank-layout'">
    <Nuxt />
    <portal-target name="modal" />
  </div>
</template>

<script>
export default {
  name: 'Blank',
  data () {
    return {
      faq: false
    }
  },
  created () {
    this.faq = this.$route.path === '/faq/doctor' || this.$route.path === '/en/faq/doctor'
  }
}
</script>

<style scoped>

</style>
